function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#WordDocument_svg__clip0_1818_35828)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.51.508a.417.417 0 00-.353-.083L.323 2.925a.417.417 0 00-.323.41v14.167c0 .205.15.38.353.411l10.834 1.667a.417.417 0 00.48-.412V.835a.417.417 0 00-.157-.327z",
  fill: "#1565C0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.584 17.918H11.25a.417.417 0 010-.833h7.917V2.918H11.25a.417.417 0 010-.833h8.334c.23 0 .416.187.416.417v15c0 .23-.186.416-.416.416z",
  fill: "#1565C0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.083 13.751a.417.417 0 01-.4-.301L5.417 9.018 4.15 13.45a.433.433 0 01-.801 0L1.682 7.616a.417.417 0 11.801-.229l1.267 4.431 1.266-4.432a.433.433 0 01.801 0l1.266 4.432 1.267-4.43a.412.412 0 01.506-.29l.009.003a.417.417 0 01.286.515L7.484 13.45a.417.417 0 01-.4.301z",
  fill: "#FAFAFA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.917 5.418H11.25a.417.417 0 010-.833h6.667a.417.417 0 010 .833zM17.917 7.918H11.25a.417.417 0 010-.833h6.667a.417.417 0 010 .833zM17.917 10.418H11.25a.417.417 0 110-.833h6.667a.417.417 0 010 .833zM17.917 12.918H11.25a.417.417 0 110-.833h6.667a.417.417 0 110 .833zM17.917 15.418H11.25a.417.417 0 110-.833h6.667a.417.417 0 110 .833z",
  fill: "#1565C0"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "WordDocument_svg__clip0_1818_35828"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})));

function SvgWordDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgWordDocument;